import * as loadInventory from '../helpers/loadInventory.js';
import { countTotalAllDivs } from "../helpers/countTotal.js";
import { swiper_update_height} from "../sliders/sliders.js";

(function ($) {
    //item click
    $('.swiper .block__item-wrapper').on('click', '.pay__item', function (e) {
        if ($(this).find('input[type=checkbox]').length == 0) {
            return;
        }
        // if ($("#activ").length) {
        //     if (lang == 'ru') {
        //         addAlert('Error', `У вас уже есть активный обмен. Пожалуйста, примите обмен и обновите страницу`);
        //     } else {
        //         addAlert('Error', 'You already have active trade. Accept tradeoffer and refresh page before next trade');
        //     }
        //     return false;
        // }
        // if ($(this).find("span.lock-item").length) {
        //     return false;
        // }

        // //если это инсерт то можно макс 10 шмоток
        // if ($(this).parents('.insert_items_block').length != 0 && $('.deposit_form_block:visible .game_item.nice_item').length >= 10) {
        //     if (lang == 'ru') {
        //         addAlert('Error', `Вы не можете добавить более 10 предметов в один обмен`);
        //     } else {
        //         addAlert('Error', `You can't add more than 10 items per trade`);
        //     }
        //     return;
        // }
        let $item_wrap = $(this).closest('.block__item-wrapper');
        if ($(this).parents('.pay-basket').length != 0) {
            //move to bottom
            $(this).find('input[type=checkbox]').prop('checked', false);
            let item_appid = $(this).find('input[name="appid"]').val();
            if ($item_wrap.find('.inventory').length > 1) {
                $item_wrap.find(`.tab-item[data-tab="#${item_appid}"] .inventory`).prepend($(this));
            } else {
                $item_wrap.find('.inventory').prepend($(this));
            }
        } else {
            //move to top
            $(this).find('input[type=checkbox]').prop('checked', true);
            $item_wrap.find('.pay-basket .bet-content-show').prepend($(this));
        }
        swiper_update_height();
        countTotalAllDivs();
    })

    function click_all_items_in_pay() {
        $('.swiper-tabs-wrap .swiper-slide-visible.swiper-slide-active .pay-basket .pay__item').click();
    }

})($);